module.exports = __webpack_public_path__ + "img/kn.1ab2d7d4.svg";